import { Backend } from '../Backend';
import { IClientEvents } from './AnalyticsService'; //TODO: change to AndromeTV.types type

export class AnalyticsApi {
  static log(backend: Backend, body: IClientEvents) {
    const url = backend.makeUrl('v1/log');
    return backend.postJson(url, body, backend.bearer);
  }
}
